import styles from '../../assets/styles/Catalogue/StyleCatalogue.module.scss';
import { MimaText, PageLoader } from '../../components';
import React, { useMemo } from 'react';
import Footer from './Footer';
import { useCatalogUtility } from '../../hooks';
import CatalogHomeHeader from './CatalogHomeHeader';
import DOMPurify from 'dompurify';

const RefundPolicy = () => {
	const {
		filtering,
		setFiltering,
		setCollectionQuery,
		data,
		setSearchQuery,
		setCurrencyCode,
		showSearch,
		setShowSearch,
		isLoading,
	} = useCatalogUtility();

	const refundPolicy = useMemo(() => {
		return data?.data?.websiteSettings?.content?.refundPolicy || '';
	}, [data]);

	const sanitizedRefundPolicy = useMemo(
		() => DOMPurify.sanitize(refundPolicy),
		[refundPolicy]
	);

	return (
		<main>
			<CatalogHomeHeader
				filtering={filtering}
				setFiltering={setFiltering}
				setCollectionQuery={setCollectionQuery}
				data={data}
				setSearchQuery={setSearchQuery}
				setCurrencyCode={setCurrencyCode}
				showSearch={showSearch}
				setShowSearch={setShowSearch}
			/>

			{isLoading ? (
				<div style={{ marginTop: '15rem' }}>
					<PageLoader />
				</div>
			) : (
				<>
					<div className={styles.content}>
						<MimaText
							variant="h3"
							align="center"
							color="var(--color-dark)"
							mb={3}>
							Our Refund Policy
						</MimaText>

						<div dangerouslySetInnerHTML={{ __html: sanitizedRefundPolicy }} />
					</div>

					<Footer data={data} />
				</>
			)}
		</main>
	);
};

export default RefundPolicy;
